// extracted by mini-css-extract-plugin
module.exports = {"backIconArea":"search-autocomplete-trigger_backIconArea__SUbaS","backIcon":"search-autocomplete-trigger_backIcon__mPClV"};